<script>
    import { onMount } from "svelte";
    import { AuthUser } from "../store.js";
    import wrappedFetch from "../wrappedFetch.js";
    import Card from "./components/card.svelte";
    import Message from "./components/message.svelte";

    let appsnew = [];
    let apps = [];

    $: {
        getApps();
    }
    
    onMount(async () => {
        getApps();
    });

    const handleInstall = async (app) => {
        let resp = await wrappedFetch("/api/apps/Install?appId=" + app.appId, {
            method: "get",
        });

        if (resp.status === 200) {
            // Get the data
            const data = await resp.json();
        } else {
            // Handle non-200 status codes or server errors
            console.error("Error: Request failed with status", resp.status);
        }

        getApps();


    };

    const getApps = async () => {
        let resp = await wrappedFetch("/api/apps/getapps", { method: "get" });
        let apps = await resp.json();
        appsnew = apps.filter((app) => app.isInstalled === false);

    };
</script>

<style>
    .img-responsive {
        width: 100%;
        height: auto;
    }
</style>

<svelte:head>
    <title>Discover | Wavenet Nimbus </title>
</svelte:head>

<h1>Discover</h1>

<div class="row">
    <div class="col-12">
        <div class="row mt-3">
            {#if appsnew.length > 0}
                {#each appsnew as app}
                    <div class="col-sm-6 col-md-4 col-lg-3 text-center d-flex mb-4">
                        <Card>
                            <div slot="body">
                                <a href="{app.configUrl}" on:click={() => handleInstall(app)} target="_self">
                                    <img src={app.imageUrl} alt={app.name} class="img-responsive">
                                </a>
                            </div>
                            <div slot="footer">
                                <button class="btn btn-danger" on:click={() => handleInstall(app)}>Install</button>
                            </div>
                        </Card>
                    </div>
                {/each}
            {:else}
                <div class="col-12">
                    <Message message="All available apps are installed. More apps will be coming soon."></Message>
                </div>
            {/if}
        </div>
    </div>
</div>
